export class ProfileHoursTranslations {
  public hours?: string;
  public allDay?: string;
  public weekendHours?: string;
  public extendedHours?: string;
  public sun?: string;
  public mon?: string;
  public tue?: string;
  public wed?: string;
  public thu?: string;
  public fri?: string;
  public sat?: string;

  constructor(obj?: ProfileHoursTranslations) {
    obj = obj || ({} as ProfileHoursTranslations);
    this.hours = obj.hours || 'Hours of Operation';
    this.allDay = obj.allDay || '24 Hours';
    this.weekendHours = obj.weekendHours || 'This facility has weekend hours.';
    this.extendedHours =
      obj.extendedHours || 'This facility has extended hours.';
    this.sun = obj.sun || 'Sunday';
    this.mon = obj.mon || 'Monday';
    this.tue = obj.tue || 'Tuesday';
    this.wed = obj.wed || 'Wednesday';
    this.thu = obj.thu || 'Thursday';
    this.fri = obj.fri || 'Friday';
    this.sat = obj.sat || 'Saturday';
  }
}
